export enum ACTIVITY_TYPES {
  EXCAVATION = 'excavation',
  BUILD = 'build',
  OTHER = 'other',
}
